import FileSelection from 'common/components/file/FileSelection'
import React, { useState } from 'react'
import { Button, Card, CardContent, Dialog, DialogContent, Grid } from '@mui/material'
import useTitles from 'common/hooks/useTitles'
import { BasicDialogTitle } from 'common/components/modal/DialogComponents'
import IssuesAction from 'common/actions/IssuesAction'

const IssueApp = () => {
    const [file, setFile] = useState([])
    const [isOpen, setIsOpen] = useState(false)
    const [errors, setErrors] = useState([])

    const actionOnClick = () => {
        if (file.length !== 0) {
            IssuesAction.createIssues(file[0], setIsOpen, setErrors).then(
                setFile([])
            )
        }
    }

    useTitles(() => [{
        label: 'Création de Tickets',
        href: '/issue',
    }], [])

    const disabledButton = file.length === 0

    return (
        <>
            <Grid container direction='column' height='100%' spacing={1}>
                <Grid container justifyContent='center' marginTop={1}>
                    <Card sx={{ padding: 1, flex: 1 }}>
                        <Grid container direction='column' alignItems='center' spacing={1}>
                            <Grid>Vous pouvez directement créer plusieurs tickets sur MantisBT grâce à un fichier Excel :</Grid>
                            <Grid>
                            Pour cela, vous pouvez télécharger le modèle et le compléter :
                                <Button variant='contained'
                                    component='a'
                                    href='AjoutTicketMantis.xlsx'
                                    download
                                    sx={{ marginTop: 1, marginLeft: 1 }}
                                >Télécharger le modèle</Button>
                            </Grid>
                            <Grid container spacing={0} direction='column' alignItems='center'>
                                <Grid>
                                Si vous voulez ajouter une ligne pour créer un ticket supplémentaire, il faut que vous sélectionnez la ligne
                                </Grid>
                                <Grid>
                                du dessus et que vous la fassiez glisser en prenant bien également le nombre (pour que la gestion d'erreur se fasse bien sur la ligne).
                                </Grid>
                            </Grid>
                            <Grid>Veuillez également vérifier si l'utilisateur que vous mettez a bel et bien accès au projet en question.</Grid>
                        </Grid>
                    </Card>
                </Grid>
                <Grid sx={{ flex: 1 }}>
                    <FileSelection files={file} setFiles={setFile} fileAccept='.xlsx, .xls'/>
                </Grid>
                <Grid container justifyContent='center' marginBottom={1} >
                    <Button onClick={actionOnClick} sx={{ padding: '10 25px', borderRadius: '20px', backgroundColor: disabledButton ? 'grey' :'primary.main', width: 'auto' }} disabled={disabledButton}>
                        <Grid sx={{ color: 'white' }} >{'Valider'}</Grid>
                    </Button>
                </Grid>
            </Grid>
            <Dialog
                open={isOpen}
                maxWidth='lg'
            >
                <BasicDialogTitle onClose={()=> {
                    setIsOpen(false)
                    setErrors([])
                }}
                >
                    Erreur lors de la création des tickets
                </BasicDialogTitle>
                <DialogContent>
                    <Card>
                        <CardContent>
                            <Grid spacing={1} direction='column'>
                                <Grid> Voici les erreurs qui se sont déclanchées lors de la création des tickets :</Grid>
                                {errors.map((err, index) => (
                                    <Grid key={index}>
                                        <span style={{ whiteSpace: 'pre' }}>{`          - ${err}`}</span>
                                    </Grid>
                                ))}

                            </Grid>
                        </CardContent>
                    </Card>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default IssueApp